import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./components/Home";
import Pillow from "./components/Pillow";
import "./App.css";

export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/Pillow" component={Pillow} />
      </Switch>
    </BrowserRouter>
  );
}
